import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CalculateQuotaRequest, CalculateQuotaResponse } from '../../models/calculateQuota';

import { QuotaApiService } from './quota.api.service';
import { Quota } from '../../models/quota';
import { TotalUserQuota } from '../../models/TotalUserQuota';
import { QuotaDetail } from '../../models/quotaDetails';
import { QuotaHistory } from '../../models/quotaHistory';

@Injectable()
export class QuotaDomainService {

    constructor(private quotaApiService: QuotaApiService) { }

    getOwnQuota(): Observable<QuotaDetail> {
        return this.quotaApiService.getOwnQuota();
    }

    getQuotaHistory(companyId: string, userId: string, from: string, to: string): Observable<QuotaHistory[]> {
        return this.quotaApiService.getQuotaHistory(companyId, userId, from, to);
    }

    getQuotaForCompanies(): Observable<{} | QuotaDetail> {
        return this.quotaApiService.getQuotaForCompanies();
    }

    getAllQuotasForCompany(companyId: string): Observable<{} | QuotaDetail> {
        return this.quotaApiService.getAllQuotasForCompany(companyId);
    }

    setQuotaForCompany(companyId: string, quota: { quota?: number; apiKey?: string }): Observable<{} | boolean> {
        return this.quotaApiService.setQuotaForCompany(companyId, quota);
    }

    getQuotaForCompanyUsers(companyId: string): Observable<{} | Quota[]> {
        return this.quotaApiService.getQuotaForCompanyUsers(companyId);
    }

    setQuotaForUser(companyId: string, userId: string, quotaLimit: number): Observable<{} | boolean> {
        return this.quotaApiService.setQuotaForUser(companyId, userId, quotaLimit);
    }

    calculateQuota(request: CalculateQuotaRequest): Observable<CalculateQuotaResponse> {
        return this.quotaApiService.calculateQuota(request);
    }

    getTotalQuota(): Observable<{} | TotalUserQuota> {
        return this.quotaApiService.getTotalQuota();
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/quota/quota.domain.service.ts